import { ReactElement } from "react";
import Modify from "@shared/FormTemplates/Modify";
import ModifyForm from "./ModifyForm";
import updateItem from "@services/Clients/WhaleShark/partner/updateItem";
import useGetDetailItem from "@hooks/Clients/WhaleShark/partner/useGetPartner";
import validator from "@validators/Clients/WhaleShark/partner/Partner.validate";
import formMapper from "@mappers/Clients/WhaleShark/partner/PartnerItem.mapper";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
